import React from 'react';
import { CellRadioGroup } from '@root/components/Cell';
import useSelectCountry from '@root/hooks/bill/useSelectCountry';
import { countryData } from '@root/constant';

const SelectCountry = () => {
  const { countryCode, onSelect } = useSelectCountry();

  return (
    <CellRadioGroup
      marginTop={20}
      value={countryCode}
      options={countryData.map((i) => ({
        value: i.countryCode,
        title: i.countryName,
      }))}
      onChange={onSelect}
    />
  );
};

export default SelectCountry;
